import React, {useEffect, useState} from "react";

export const Section1Form9=React.memo(({form9Data})=>{

    return (
        <div className={"mt-2"}>
            <table>
                <tbody>
                <tr>
                    {/*=========col1====*/}
                    <td>
                        ग्रामपंचायत कार्यालय :
                    </td>
                    <td>
                        <input
                            disabled={true}
                            value={form9Data.GramPanchayat_Name1}
                        />
                    </td>
                    {/*=========col2====*/}
                    <td>
                        ता.पं.स.:
                    </td>
                    <td><input
                        disabled={true}
                        value={form9Data.Taluka_Name}
                    /></td>
                    {/*=========col3====*/}
                    <td>जिल्हा परिषद :	</td>
                    <td><input
                        disabled={true}
                        value={form9Data.Zilla_Name}
                    /></td>
                    {/*=========col4====*/}
                    <td> मालमत्तेचे वर्णन :	</td>
                    <td><input
                        disabled={true}
                        value={JSON.parse(form9Data.ExtendData)[0].Col9}
                    /></td>
                    {/*=========col5====*/}
                    <td></td>
                </tr>
                </tbody>
            </table>
        </div>
    )
})

export const Section2Form9=React.memo(({form9Data})=>{

    return (
        <div className={"mt-2"}>
            <table>
                <tbody>
                <tr>
                    {/*=========col1====*/}
                    <td>भोगवटदाराचे नाव :</td>
                    <td>
                        <input
                            value={form9Data.Occupant_Name}
                            disabled={true}
                        />
                    </td>
                    {/*=========col2====*/}
                    <td>मालमत्ता धारकाचे नाव :
                    </td>
                    <td><input value={form9Data.Owner_Name} disabled={true} /></td>
                    {/*=========col3====*/}
                    <td> मालमत्ता क्र. :	</td>
                    <td><input value={form9Data.Property_No} disabled={true}/></td>
                </tr>
                </tbody>
            </table>
        </div>
    )
})

export const Form9BigTable=React.memo(({selectedYear,form9Data})=>{

    return (
        <table className="table  table-bordered mt-2 big-table9">
            <thead>
            <LabelHeader/>
            </thead>
            <tbody>
                <Smallable/>
                <Row1 selectedYear={selectedYear} form9Data={form9Data} />
                <Row2/>
                <Row2/>
                <Row4/>
            </tbody>
        </table>
    )
})

const LabelHeader = React.memo(() => {
    return (
        <tr>
            <th>अनु. क्र</th>
            <th className={"size1"}>वर्ष</th>
            <th colSpan={3}>गृहकर</th>
            <th colSpan={3}>खाली जागा कर</th>
            <th colSpan={3}>वीजकर</th>
            <th colSpan={3}>आरोग्य कर</th>
            <th colSpan={3}>एकूण कर</th>
            <th>पावती क्र व दिनांक</th>
            <th colSpan={3}>सा.पाणीकर</th>
            <th colSpan={3}>विशेष पाणीकर</th>
            <th>शेरा/सूट जर कमी केल्याचा आदेश</th>
        </tr>
    );
});
const Smallable=React.memo(()=>{

    function TreeColumn() {

        return <>
            <td>थकीत</td>
            <td>चालू</td>
            <td>एकूण</td>
        </>

    }

    return (
        <tr>
            <td></td>
            <td></td>
            <TreeColumn/>
            <TreeColumn/>
            <TreeColumn/>
            <TreeColumn/>
            <TreeColumn/>
            <td></td>
            <TreeColumn/>
            <TreeColumn/>
            <td></td>

        </tr>
    )
})

const TreeInput=React.memo(({isDisable=false,pending,onPending,onBlurPending,running,onRunning,onBlurRunning,total,onTotal})=>{
    return <>
        <td><input disabled={isDisable} value={pending} onChange={onPending} onBlur={onBlurPending}/></td>
        <td><input disabled={isDisable} value={running} onChange={onRunning} onBlur={onBlurRunning}/></td>
        <td><input disabled={true} value={total} onChange={onTotal}/></td>
    </>
})
const TextAndDate=React.memo(()=>{
    return <td>
        <input/> <br/>
        <input placeholder={"dd/mm/yyyy"}/>
    </td>
})

const Row1=React.memo(({selectedYear,form9Data})=>{
    const today = new Date();
    const currentYear = today.getFullYear();
    const nextYear = currentYear + 1;
    const [row,setRow]=useState({
        ghara_kara:{
            pending:0,
            running:parseFloat(form9Data.Total_groung),
            total:0,
        },
        open_space:{
            pending:0,
            running:parseFloat(form9Data.Bhomikar).toFixed(2),
            total:0,
        },
        electricity_tax:{
            pending:0,
            running:JSON.parse(form9Data.Box).box3,
            total:0,
        },
        health_tax:{
            pending:0,
            running:JSON.parse(form9Data.Box).box4,
            total:0,
        },
        total_tax:{
            pending:0,
            running:0,
            total:0,
        },
        Receipt_No_and_Date:{
            sr_no:"",
            date:"",
        },
        S_Panikar:{
            pending:0,
            running:JSON.parse(form9Data.Box).box5,
            total:0,
        },
        Special_water_tax:{
            pending:0,
            running:JSON.parse(form9Data.Box).box6,
            total:0,
        },

    })


    const updateRowField = (mainKey, subKey, value) => {
        setRow(prev => ({
            ...prev,
            [mainKey]: {
                ...prev[mainKey],
                [subKey]: value,
            }
        }));
    };

    function calhomeTax(value) {
        //===============calTotalPendingTax===========
        let home_tax_pending=value;
        let remain_land_tax_pending=parseFloat(row.open_space.pending);
        let vij_tax_pending=parseFloat(row.electricity_tax.pending);
        let arogy_tax_pending=parseFloat(row.health_tax.pending);
        let total_tax_pending = home_tax_pending +remain_land_tax_pending+ vij_tax_pending + arogy_tax_pending;
        updateRowField("total_tax","pending",total_tax_pending.toFixed(3));
        //===============calTotalCurrentTax===========
        let home_tax_current=parseFloat(row.ghara_kara.running);
        let remain_land_tax_current=parseFloat(row.open_space.running);
        let vij_tax_current=parseFloat(row.electricity_tax.running);
        let arogy_tax_current=parseFloat(row.health_tax.running);
        let total_tax_current =home_tax_current+remain_land_tax_current+vij_tax_current+arogy_tax_current;
        updateRowField("total_tax","running",total_tax_current.toFixed(3));
        //=================calTotalTaxTotal============
        let home_tax_total=parseFloat(row.ghara_kara.total);
        let remain_land_tax_total=parseFloat(row.open_space.total);
        let vij_tax_total=parseFloat(row.electricity_tax.total);
        let arogy_tax_total=parseFloat(row.health_tax.total);
        let total_tax_total= home_tax_total+remain_land_tax_total+ vij_tax_total+arogy_tax_total;
        updateRowField("total_tax","total",total_tax_total.toFixed(3));
    }

    return <tr>
        <td rowSpan={4}>1</td>
        <td className={"size1"}> सन {selectedYear} ची कर मागणी</td>
        <TreeInput pending={row.ghara_kara.pending}
                   onPending={(e)=>{updateRowField("ghara_kara","pending",e.target.value)}}
                   running={row.ghara_kara.running}
                   onRunning={(e)=>{updateRowField("ghara_kara","running",e.target.value)}}
                   total={row.ghara_kara.total}
                   onTotal={(e)=>{updateRowField("ghara_kara","total",e.target.value)}}
                   onBlurPending={()=>{
                       let value=parseFloat(row.ghara_kara.pending);
                       value=value+(value/20);
                       updateRowField("ghara_kara","pending",value.toFixed(3));
                       //===================calhomeTax=======
                       updateRowField("ghara_kara","total",(parseFloat(value)+parseFloat(row.ghara_kara.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.ghara_kara.pending);
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.open_space.pending}
                   onPending={(e)=>{updateRowField("open_space","pending",e.target.value)}}
                   running={row.open_space.running}
                   onRunning={(e)=>{updateRowField("open_space","running",e.target.value)}}
                   total={row.open_space.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.open_space.pending);
                       value=value+(value/20);
                       updateRowField("open_space","pending",value.toFixed(3));
                       //==========calRemainLandTax======
                       updateRowField("open_space","total",(value+parseFloat(row.open_space.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.open_space.pending);
                       //==========calRemainLandTax======
                       updateRowField("open_space","total",(value+parseFloat(row.open_space.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.electricity_tax.pending}
                   onPending={(e)=>{updateRowField("electricity_tax","pending",e.target.value)}}
                   running={row.electricity_tax.running}
                   onRunning={(e)=>{updateRowField("electricity_tax","running",e.target.value)}}
                   total={row.electricity_tax.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.electricity_tax.pending);
                       value=value+(value/20);
                       updateRowField("electricity_tax","pending",value.toFixed(3));
                       updateRowField("electricity_tax","total",(value+parseFloat(row.electricity_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.electricity_tax.pending);
                       updateRowField("electricity_tax","total",(value+parseFloat(row.electricity_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.health_tax.pending}
                   onPending={(e)=>{updateRowField("health_tax","pending",e.target.value)}}
                   running={row.health_tax.running}
                   onRunning={(e)=>{updateRowField("health_tax","running",e.target.value)}}
                   total={row.health_tax.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.health_tax.pending);
                       value=value+(value/20);
                       updateRowField("health_tax","pending",value.toFixed(3));
                       updateRowField("health_tax","total",(value+parseFloat(row.health_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.health_tax.pending);
                       updateRowField("health_tax","total",(value+parseFloat(row.health_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.total_tax.pending}
                   onPending={(e)=>{updateRowField("total_tax","pending",e.target.value)}}
                   running={row.total_tax.running}
                   onRunning={(e)=>{updateRowField("total_tax","running",e.target.value)}}
                   total={row.total_tax.total}
                   isDisable={true}
        />
        <TextAndDate/>
        <TreeInput pending={row.S_Panikar.pending}
                   onPending={(e)=>{updateRowField("S_Panikar","pending",e.target.value)}}
                   running={row.S_Panikar.running}
                   onRunning={(e)=>{updateRowField("S_Panikar","running",e.target.value)}}
                   total={row.S_Panikar.total}
                   onBlurPending={()=>{
                       let pending=parseFloat(row.S_Panikar.pending);
                       let running=parseFloat(row.S_Panikar.running);
                       updateRowField("S_Panikar","total",(pending+running).toFixed(3));
                   }}
                   onBlurRunning={()=>{
                       let pending=parseFloat(row.S_Panikar.pending);
                       let running=parseFloat(row.S_Panikar.running);
                       updateRowField("S_Panikar","total",(pending+running).toFixed(3));
                   }}
        />
        <TreeInput pending={row.Special_water_tax.pending}
                   onPending={(e)=>{updateRowField("Special_water_tax","pending",e.target.value)}}
                   running={row.Special_water_tax.running}
                   onRunning={(e)=>{updateRowField("Special_water_tax","running",e.target.value)}}
                   total={row.Special_water_tax.total}
                   onBlurPending={()=>{
                       let pending=parseFloat(row.Special_water_tax.pending);
                       let running=parseFloat(row.Special_water_tax.running);
                       updateRowField("Special_water_tax","total",(pending+running).toFixed(3));
                   }}
                   onBlurRunning={()=>{
                       let pending=parseFloat(row.Special_water_tax.pending);
                       let running=parseFloat(row.Special_water_tax.running);
                       updateRowField("Special_water_tax","total",(pending+running).toFixed(3));
                   }}
        />
        <td><input/></td>

    </tr>
})
const Row2=React.memo(()=>{
    const [row,setRow]=useState({
        ghara_kara:{
            pending:0,
            running:0,
            total:0,
        },
        open_space:{
            pending:0,
            running:0,
            total:0,
        },
        electricity_tax:{
            pending:0,
            running:0,
            total:0,
        },
        health_tax:{
            pending:0,
            running:0,
            total:0,
        },
        total_tax:{
            pending:0,
            running:0,
            total:0,
        },
        Receipt_No_and_Date:{
            sr_no:"",
            date:"",
        },
        S_Panikar:{
            pending:0,
            running:0,
            total:0,
        },
        Special_water_tax:{
            pending:0,
            running:0,
            total:0,
        },

    })
    const updateRowField = (mainKey, subKey, value) => {
        setRow(prev => ({
            ...prev,
            [mainKey]: {
                ...prev[mainKey],
                [subKey]: value,
            }
        }));
    };

    function calhomeTax(value) {
        //===============calTotalPendingTax===========
        let home_tax_pending=value;
        let remain_land_tax_pending=parseFloat(row.open_space.pending);
        let vij_tax_pending=parseFloat(row.electricity_tax.pending);
        let arogy_tax_pending=parseFloat(row.health_tax.pending);
        let total_tax_pending = home_tax_pending +remain_land_tax_pending+ vij_tax_pending + arogy_tax_pending;
        updateRowField("total_tax","pending",total_tax_pending.toFixed(3));
        //===============calTotalCurrentTax===========
        let home_tax_current=parseFloat(row.ghara_kara.running);
        let remain_land_tax_current=parseFloat(row.open_space.running);
        let vij_tax_current=parseFloat(row.electricity_tax.running);
        let arogy_tax_current=parseFloat(row.health_tax.running);
        let total_tax_current =home_tax_current+remain_land_tax_current+vij_tax_current+arogy_tax_current;
        updateRowField("total_tax","running",total_tax_current.toFixed(3));
        //=================calTotalTaxTotal============
        let home_tax_total=parseFloat(row.ghara_kara.total);
        let remain_land_tax_total=parseFloat(row.open_space.total);
        let vij_tax_total=parseFloat(row.electricity_tax.total);
        let arogy_tax_total=parseFloat(row.health_tax.total);
        let total_tax_total= home_tax_total+remain_land_tax_total+ vij_tax_total+arogy_tax_total;
        updateRowField("total_tax","total",total_tax_total.toFixed(3));
    }
    return <tr>
        <td className={"size1"}>वसुली पा. क्र.<input/>दि.<input placeholder={"dd/mm/yyyy"}/></td>
        <TreeInput pending={row.ghara_kara.pending}
                   onPending={(e)=>{updateRowField("ghara_kara","pending",e.target.value)}}
                   running={row.ghara_kara.running}
                   onRunning={(e)=>{updateRowField("ghara_kara","running",e.target.value)}}
                   total={row.ghara_kara.total}
                   onTotal={(e)=>{updateRowField("ghara_kara","total",e.target.value)}}
                   onBlurPending={()=>{
                       let value=parseFloat(row.ghara_kara.pending);
                       value=value+(value/20);
                       updateRowField("ghara_kara","pending",value.toFixed(3));
                       //===================calhomeTax=======
                       updateRowField("ghara_kara","total",(parseFloat(value)+parseFloat(row.ghara_kara.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.ghara_kara.pending);
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.open_space.pending}
                   onPending={(e)=>{updateRowField("open_space","pending",e.target.value)}}
                   running={row.open_space.running}
                   onRunning={(e)=>{updateRowField("open_space","running",e.target.value)}}
                   total={row.open_space.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.open_space.pending);
                       value=value+(value/20);
                       updateRowField("open_space","pending",value.toFixed(3));
                       //==========calRemainLandTax======
                       updateRowField("open_space","total",(value+parseFloat(row.open_space.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.open_space.pending);
                       //==========calRemainLandTax======
                       updateRowField("open_space","total",(value+parseFloat(row.open_space.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.electricity_tax.pending}
                   onPending={(e)=>{updateRowField("electricity_tax","pending",e.target.value)}}
                   running={row.electricity_tax.running}
                   onRunning={(e)=>{updateRowField("electricity_tax","running",e.target.value)}}
                   total={row.electricity_tax.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.electricity_tax.pending);
                       value=value+(value/20);
                       updateRowField("electricity_tax","pending",value.toFixed(3));
                       updateRowField("electricity_tax","total",(value+parseFloat(row.electricity_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.electricity_tax.pending);
                       updateRowField("electricity_tax","total",(value+parseFloat(row.electricity_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.health_tax.pending}
                   onPending={(e)=>{updateRowField("health_tax","pending",e.target.value)}}
                   running={row.health_tax.running}
                   onRunning={(e)=>{updateRowField("health_tax","running",e.target.value)}}
                   total={row.health_tax.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.health_tax.pending);
                       value=value+(value/20);
                       updateRowField("health_tax","pending",value.toFixed(3));
                       updateRowField("health_tax","total",(value+parseFloat(row.health_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.health_tax.pending);
                       updateRowField("health_tax","total",(value+parseFloat(row.health_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.total_tax.pending}
                   onPending={(e)=>{updateRowField("total_tax","pending",e.target.value)}}
                   running={row.total_tax.running}
                   onRunning={(e)=>{updateRowField("total_tax","running",e.target.value)}}
                   total={row.total_tax.total}
                   isDisable={true}
        />
        <TextAndDate/>
        <TreeInput pending={row.S_Panikar.pending}
                   onPending={(e)=>{updateRowField("S_Panikar","pending",e.target.value)}}
                   running={row.S_Panikar.running}
                   onRunning={(e)=>{updateRowField("S_Panikar","running",e.target.value)}}
                   total={row.S_Panikar.total}
                   onBlurPending={()=>{
                       let pending=parseFloat(row.S_Panikar.pending);
                       let running=parseFloat(row.S_Panikar.running);
                       updateRowField("S_Panikar","total",(pending+running).toFixed(3));
                   }}
                   onBlurRunning={()=>{
                       let pending=parseFloat(row.S_Panikar.pending);
                       let running=parseFloat(row.S_Panikar.running);
                       updateRowField("S_Panikar","total",(pending+running).toFixed(3));
                   }}
        />
        <TreeInput pending={row.Special_water_tax.pending}
                   onPending={(e)=>{updateRowField("Special_water_tax","pending",e.target.value)}}
                   running={row.Special_water_tax.running}
                   onRunning={(e)=>{updateRowField("Special_water_tax","running",e.target.value)}}
                   total={row.Special_water_tax.total}
                   onBlurPending={()=>{
                       let pending=parseFloat(row.Special_water_tax.pending);
                       let running=parseFloat(row.Special_water_tax.running);
                       updateRowField("Special_water_tax","total",(pending+running).toFixed(3));
                   }}
                   onBlurRunning={()=>{
                       let pending=parseFloat(row.Special_water_tax.pending);
                       let running=parseFloat(row.Special_water_tax.running);
                       updateRowField("Special_water_tax","total",(pending+running).toFixed(3));
                   }}
        />
        <td><input/></td>
    </tr>
})
const Row4=React.memo(()=>{
    const [row,setRow]=useState({
        ghara_kara:{
            pending:0,
            running:0,
            total:0,
        },
        open_space:{
            pending:0,
            running:0,
            total:0,
        },
        electricity_tax:{
            pending:0,
            running:0,
            total:0,
        },
        health_tax:{
            pending:0,
            running:0,
            total:0,
        },
        total_tax:{
            pending:0,
            running:0,
            total:0,
        },
        Receipt_No_and_Date:{
            sr_no:"",
            date:"",
        },
        S_Panikar:{
            pending:0,
            running:0,
            total:0,
        },
        Special_water_tax:{
            pending:0,
            running:0,
            total:0,
        },

    })
    const updateRowField = (mainKey, subKey, value) => {
        setRow(prev => ({
            ...prev,
            [mainKey]: {
                ...prev[mainKey],
                [subKey]: value,
            }
        }));
    };

    function calhomeTax(value) {
        //===============calTotalPendingTax===========
        let home_tax_pending=value;
        let remain_land_tax_pending=parseFloat(row.open_space.pending);
        let vij_tax_pending=parseFloat(row.electricity_tax.pending);
        let arogy_tax_pending=parseFloat(row.health_tax.pending);
        let total_tax_pending = home_tax_pending +remain_land_tax_pending+ vij_tax_pending + arogy_tax_pending;
        updateRowField("total_tax","pending",total_tax_pending.toFixed(3));
        //===============calTotalCurrentTax===========
        let home_tax_current=parseFloat(row.ghara_kara.running);
        let remain_land_tax_current=parseFloat(row.open_space.running);
        let vij_tax_current=parseFloat(row.electricity_tax.running);
        let arogy_tax_current=parseFloat(row.health_tax.running);
        let total_tax_current =home_tax_current+remain_land_tax_current+vij_tax_current+arogy_tax_current;
        updateRowField("total_tax","running",total_tax_current.toFixed(3));
        //=================calTotalTaxTotal============
        let home_tax_total=parseFloat(row.ghara_kara.total);
        let remain_land_tax_total=parseFloat(row.open_space.total);
        let vij_tax_total=parseFloat(row.electricity_tax.total);
        let arogy_tax_total=parseFloat(row.health_tax.total);
        let total_tax_total= home_tax_total+remain_land_tax_total+ vij_tax_total+arogy_tax_total;
        updateRowField("total_tax","total",total_tax_total.toFixed(3));
    }
    return <tr>
        <td className={"size1"}>वसुली थकबाकी</td>
        <TreeInput pending={row.ghara_kara.pending}
                   onPending={(e)=>{updateRowField("ghara_kara","pending",e.target.value)}}
                   running={row.ghara_kara.running}
                   onRunning={(e)=>{updateRowField("ghara_kara","running",e.target.value)}}
                   total={row.ghara_kara.total}
                   onTotal={(e)=>{updateRowField("ghara_kara","total",e.target.value)}}
                   onBlurPending={()=>{
                       let value=parseFloat(row.ghara_kara.pending);
                       value=value+(value/20);
                       updateRowField("ghara_kara","pending",value.toFixed(3));
                       //===================calhomeTax=======
                       updateRowField("ghara_kara","total",(parseFloat(value)+parseFloat(row.ghara_kara.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.ghara_kara.pending);
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.open_space.pending}
                   onPending={(e)=>{updateRowField("open_space","pending",e.target.value)}}
                   running={row.open_space.running}
                   onRunning={(e)=>{updateRowField("open_space","running",e.target.value)}}
                   total={row.open_space.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.open_space.pending);
                       value=value+(value/20);
                       updateRowField("open_space","pending",value.toFixed(3));
                       //==========calRemainLandTax======
                       updateRowField("open_space","total",(value+parseFloat(row.open_space.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.open_space.pending);
                       //==========calRemainLandTax======
                       updateRowField("open_space","total",(value+parseFloat(row.open_space.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.electricity_tax.pending}
                   onPending={(e)=>{updateRowField("electricity_tax","pending",e.target.value)}}
                   running={row.electricity_tax.running}
                   onRunning={(e)=>{updateRowField("electricity_tax","running",e.target.value)}}
                   total={row.electricity_tax.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.electricity_tax.pending);
                       value=value+(value/20);
                       updateRowField("electricity_tax","pending",value.toFixed(3));
                       updateRowField("electricity_tax","total",(value+parseFloat(row.electricity_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.electricity_tax.pending);
                       updateRowField("electricity_tax","total",(value+parseFloat(row.electricity_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.health_tax.pending}
                   onPending={(e)=>{updateRowField("health_tax","pending",e.target.value)}}
                   running={row.health_tax.running}
                   onRunning={(e)=>{updateRowField("health_tax","running",e.target.value)}}
                   total={row.health_tax.total}
                   onBlurPending={()=>{
                       let value=parseFloat(row.health_tax.pending);
                       value=value+(value/20);
                       updateRowField("health_tax","pending",value.toFixed(3));
                       updateRowField("health_tax","total",(value+parseFloat(row.health_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
                   onBlurRunning={()=>{
                       let value=parseFloat(row.health_tax.pending);
                       updateRowField("health_tax","total",(value+parseFloat(row.health_tax.running)).toFixed(3));
                       calhomeTax(value);
                   }}
        />
        <TreeInput pending={row.total_tax.pending}
                   onPending={(e)=>{updateRowField("total_tax","pending",e.target.value)}}
                   running={row.total_tax.running}
                   onRunning={(e)=>{updateRowField("total_tax","running",e.target.value)}}
                   total={row.total_tax.total}
                   isDisable={true}
        />
        <TextAndDate/>
        <TreeInput pending={row.S_Panikar.pending}
                   onPending={(e)=>{updateRowField("S_Panikar","pending",e.target.value)}}
                   running={row.S_Panikar.running}
                   onRunning={(e)=>{updateRowField("S_Panikar","running",e.target.value)}}
                   total={row.S_Panikar.total}
                   onBlurPending={()=>{
                       let pending=parseFloat(row.S_Panikar.pending);
                       let running=parseFloat(row.S_Panikar.running);
                       updateRowField("S_Panikar","total",(pending+running).toFixed(3));
                   }}
                   onBlurRunning={()=>{
                       let pending=parseFloat(row.S_Panikar.pending);
                       let running=parseFloat(row.S_Panikar.running);
                       updateRowField("S_Panikar","total",(pending+running).toFixed(3));
                   }}
        />
        <TreeInput pending={row.Special_water_tax.pending}
                   onPending={(e)=>{updateRowField("Special_water_tax","pending",e.target.value)}}
                   running={row.Special_water_tax.running}
                   onRunning={(e)=>{updateRowField("Special_water_tax","running",e.target.value)}}
                   total={row.Special_water_tax.total}
                   onBlurPending={()=>{
                       let pending=parseFloat(row.Special_water_tax.pending);
                       let running=parseFloat(row.Special_water_tax.running);
                       updateRowField("Special_water_tax","total",(pending+running).toFixed(3));
                   }}
                   onBlurRunning={()=>{
                       let pending=parseFloat(row.Special_water_tax.pending);
                       let running=parseFloat(row.Special_water_tax.running);
                       updateRowField("Special_water_tax","total",(pending+running).toFixed(3));
                   }}
        />
        <td><input/></td>
    </tr>
})